import url from 'url';

import { ACTION_PREFIX, CARRIER } from '../constants';
import plansSelector from './plansSelector';

export const REQUEST_PLANS = `${ACTION_PREFIX}/REQUEST_PLANS`;
export const REQUEST_PLANS_SUCCEEDED = `${ACTION_PREFIX}/REQUEST_PLANS_SUCCEEDED`;
export const REQUEST_PLANS_FAILED = `${ACTION_PREFIX}/REQUEST_PLANS_FAILED`;

const apiUrl = url.parse(process.env.API_HOST || '');

function requestPlans(carrierId) {
    return {
        type: REQUEST_PLANS,
        payload: {
            carrierId,
        },
    };
}

function requestPlansSucceeded(carrierId, plans) {
    return {
        type: REQUEST_PLANS_SUCCEEDED,
        payload: {
            carrierId,
            plans,
        },
    };
}

function requestPlansFailed() {
    return {
        type: REQUEST_PLANS_FAILED,
    };
}

function fetchPlans(carrierId) {
    return dispatch => {
        dispatch(requestPlans(carrierId));
        return fetch(
            url.format({
                protocol: apiUrl.protocol,
                host: apiUrl.host,
                pathname: `/api/1/carriers/${carrierId}/plans`,
            }),
            {
                credentials: 'same-origin',
            }
        )
            .then(response => response.json())
            .then(json => {
                dispatch(requestPlansSucceeded(carrierId, json.plans));
            })
            .catch(() => dispatch(requestPlansFailed()));
    };
}

function shouldFetchPlans(state, carrierId) {
    if (!carrierId) {
        return false;
    }
    if (carrierId === CARRIER.ILL_CHOOSE_LATER) {
        return false;
    }
    const plans = plansSelector(state, carrierId);
    return !plans;
}

export function fetchPlansIfNeeded(carrierId) {
    return (dispatch, getState) => {
        const state = getState();
        if (shouldFetchPlans(state, carrierId)) {
            return dispatch(fetchPlans(carrierId));
        } else if (!!carrierId && carrierId !== CARRIER.ILL_CHOOSE_LATER) {
            const plans = plansSelector(state, carrierId);
            dispatch(requestPlansSucceeded(carrierId, plans));
        }
    };
}
